<script>

/* Import the chart from the vue-chartjs module, included via npm dependency */
import { Line, mixins } from 'vue-chartjs'

/* Import reactiveFunc object from reactiveFunc.js */
import reactiveFunc from './reactiveFunc.js'
const r = reactiveFunc

/* Export the default component data */
export default {
  
  // Extend the Line chart type
  extends: Line,

  // Add reactiveFunctions to the mixins
	mixins: [r],  

	props: [

	  // register settings instead of 'options', just because the options prop is already registered;
	  'settings', 

	],

  data() {

		// Return the data and chart options 
		return {
			datacollection: this.chartData,
			options: this.settings,
		}

   },

   mounted() {

 		// Set the c variable so that we can access our data
    var c = this._data;

    // renderChart function renders the chart with the datacollection and options object.
    this.renderChart(c.datacollection, c.options)
    this.generateLegend()

   },

}

</script>


// WEBPACK FOOTER //
// ChartLine.vue?6f9f5f52